/* KifTech mobile UX helpers (loaded site-wide, deferred).
   1) Collection description: on mobile, show the first 2 lines with a Read more / Read less toggle.
      The full text always stays in the page (SEO and content preserved).
   2) Smooth image loading: lazy images that are still downloading fade in once loaded
      (Part C). Skipped when the visitor prefers reduced motion; images are never hidden
      without JavaScript, and an image that fails to load is shown as normal. */
(function () {
  function clampCollectionDescription() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var d = document.querySelector('.collection-hero__description');
    if (!d || d.getAttribute('data-kt-clamp')) return;
    d.setAttribute('data-kt-clamp', '1');
    d.classList.add('kt-desc-clamped');
    if (d.scrollHeight <= d.clientHeight + 2) {
      d.classList.remove('kt-desc-clamped');
      return;
    }
    if (!d.id) d.id = 'kt-collection-description';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kt-desc-toggle';
    b.textContent = 'Read more';
    b.setAttribute('aria-expanded', 'false');
    b.setAttribute('aria-controls', d.id);
    b.addEventListener('click', function () {
      var open = !d.classList.toggle('kt-desc-clamped');
      b.textContent = open ? 'Read less' : 'Read more';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    d.insertAdjacentElement('afterend', b);
  }

  function fadeInLazyImages() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var imgs = document.querySelectorAll('img[loading="lazy"]:not(.kt-img-fade)');
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.complete) return;
      img.classList.add('kt-img-fade', 'kt-img-pending');
      var done = function () { img.classList.remove('kt-img-pending'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      /* Safety net: never leave an image hidden for more than 4 seconds. */
      setTimeout(done, 4000);
    });
  }

  function init() {
    clampCollectionDescription();
    fadeInLazyImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
